<template>
  <div :class="{'quiz-sidebar': activeQuiz && activeQuiz.display_type === 'sidebar'}">
    <div v-if="activeQuiz && activeQuiz.display_type === 'sidebar'">
      <div class="d-flex align-items-start justify-content-between quiz-sidebar-left">
        <span class="close-quize-des">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24"><path
            clip-rule="evenodd"
            d="m5.00073 17.5864c-.3905.3906-.39044 1.0237.00012 1.4142s1.02372.3905 1.41421-.0001l5.58524-5.5862 5.5857 5.5857c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-5.5858-5.5858 5.5854-5.58638c.3904-.39056.3904-1.02372-.0002-1.41421-.3905-.3905-1.0237-.39044-1.4142.00012l-5.5853 5.58627-5.58572-5.58579c-.39052-.39052-1.02369-.39052-1.41421 0-.39053.39053-.39053 1.02369 0 1.41422l5.58593 5.58587z"
            fill="rgb(0,0,0)" fill-rule="evenodd"/>
        </svg>
        </span>
        <div class="d-flex flex-column w-100">
          <div class="quiz-sidebar-description" v-html="activeQuiz.sidebar_text"></div>

          <div class="quiz-sidebar-description" v-if="activeQuiz.sidebar_attachments && activeQuiz.sidebar_attachments.length">
            {{ trans('Attachments') }}
            <div v-for="file in activeQuiz.sidebar_attachments" class="mt-1">
              <a :href="file.file" target="_blank">
                <img :src="`${m_cloud_url}uteach/assets/download-2.svg`" alt="download" width="12" height="13">
                {{ file.original_name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <all-questions-one-page v-if="activeQuiz" :userId="userId"/>

    <a
      v-if="showUteachBranding"
      href="https://uteach.io"
      target="_blank"
      style="background-color: #F4F5F8;"
      class="text-center mx-auto d-block text-secondary">
      {{ trans('built with Uteach') }}
    </a>
  </div>
</template>

<script>
import Vue from 'vue';
import AllQuestionsOnePage from "../components/AllQuestionsOnePage";
import {mapMutations} from "vuex";

Vue.mixin({
  methods: {
    onConfirmHandler() {
      if (this.$route?.query?.preview) {
        return;
      }

      $('.loader').addClass('show');
      let url = `/forms/${this.$route?.params?.id ?? window._id}/confirm`;

      const allowedParams = ['course_id', 'source_id', 'source_type', 'episode_id'];
      let params = [];

      try {
        for (const queryKey in this.$route.query) {
          if (allowedParams.includes(queryKey)) {

            params.push({
              name: queryKey,
              value: this.$route.query[queryKey],
            });
          }
        }

        params = params.map(({name, value}) => `${name}=${value}`).join('&');
      } catch (e) {

      }

      if (params) {
        url += `?${params}`;
      }

      axios.post(url, {
        answers: this.$store.state.userAnswers,
        duration: this.$store.state.duration,
        email: this.$store.state.email,
        name: this.$store.state.name,
        question_ids: this.$store.state.activeQuiz.questions.map(question => question.id)
      }).then(res => {
          $('.loader').removeClass('show');

          if (!res.data.success) {
              toastr.error(res.data.message);
          } else {
            try {
              this.$router.push({name: 'confirm', params: {id: res.data.report.id}});
            } catch (e) {
              toastr.success(window.formSuccessfullySent || trans('The form successfully sent', 'tenant'));

              setTimeout(() => {
                window.location.reload();
              }, 2000)
            }
          }
      })
    }
  },
  computed: {
    showUteachBranding() {
      return !window.hasAccessForm;
    }
  }
})

export default {
  name: "Start",
  components: {
    'all-questions-one-page': AllQuestionsOnePage,
  },
  methods: {
    ...mapMutations(['fetchQuiz', 'runDuration'])
  },
  computed: {
    id() {
      try {
        return this.$route.params.id
      } catch (e) {
        return this.$attrs.id;
      }
    },
    userId() {
      try {
        return this.$attrs.user_id;
      } catch (e) {
        return this.$attrs.user_id;
      }
    }
  },
  beforeMount() {
    window._id = this.id;
    this.fetchQuiz(this.id);
    this.runDuration();
  }
}
</script>
